import React, { useEffect, useState } from "react";
import Select from "react-select";
import { getCompleteData, getItems, getYears } from "../../../actions/HomeAction";
import Axios from "../../../axios/axios";

function RentalAdvancedSearch({ filters, setFilters, currentCategoryId }) {
  const [regions, setRegions] = useState([]);
  const [years, setYears] = useState([]);
  const [brands, setBrands] = useState([]);
  const [models, setModels] = useState([]);
  const [subcategories, setSubcategories] = useState([]);

  const customSelectStyles = {
    control: (base) => ({
      ...base,
      minHeight: "38px",
      borderRadius: "6px",
      borderColor: "#ced4da",
      marginBottom: "10px",
      fontSize: "14px",
    }),
    menu: (base) => ({ ...base, zIndex: 9999 }),
  };

  useEffect(() => {
    getItems(setRegions);
    setYears(getYears());
    getCompleteData(setBrands, () => {}, setModels);
  }, []);

  useEffect(() => {
    if (!currentCategoryId) {
      setSubcategories([]);
      setFilters(prev => ({ ...prev, subcategoryId: "" }));
      return;
    }

    const fetchCategory = async () => {
      try {
        const res = await Axios.get(`/category/${currentCategoryId}`);
        setSubcategories(res.data.subcategories || []);
      } catch (err) {
        setSubcategories([]);
      }
    };

    fetchCategory();
  }, [currentCategoryId]);

  const handleSelectChange = (name, selectedOption) => {
    const val = selectedOption ? selectedOption.value : "";
    setFilters(prev => ({ ...prev, [name]: val }));
  };

  const clearFilters = () => {
    setFilters(prev => ({
      year: "",
      regionId: "",
      brandId: "",
      modelId: "",
      condition: "",
      availabilityStatus: "",
      features: "",
      certifications: "",
      subcategoryId: "",
      categoryId: prev.categoryId
    }));
  };

  const subcategoryOptions = subcategories.map(sc => ({ value: sc._id, label: sc.name }));
  const yearOptions = years.map(y => ({ value: String(y), label: String(y) }));
  const regionOptions = regions.map(r => ({ value: r._id, label: r.name }));
  const brandOptions = brands.map(b => ({ value: b._id, label: b.name }));
  const modelOptions = models.map(m => ({ value: m._id, label: m.name }));

  const conditionOptions = [
    { value: "New", label: "New" },
    { value: "Good", label: "Good" },
    { value: "Average", label: "Average" },
    { value: "Needs Repair", label: "Needs Repair" },
  ];

  const availabilityOptions = [
    { value: "Available", label: "Available" },
    { value: "Rented", label: "Rented" },
    { value: "Under Maintenance", label: "Under Maintenance" },
  ];

  const featureOptions = [
    { value: "Heavy Duty", label: "Heavy Duty" },
    { value: "GPS Tracking", label: "GPS Tracking" },
    { value: "Low Fuel Consumption", label: "Low Fuel Consumption" },
    { value: "Hydraulic Lift", label: "Hydraulic Lift" },
    { value: "Operator Included", label: "Operator Included" },
    { value: "High Capacity", label: "High Capacity" },
  ];

  const certificationOptions = [
    { value: "ISO Certified", label: "ISO Certified" },
    { value: "Safety Inspected", label: "Safety Inspected" },
    { value: "OSHA Compliant", label: "OSHA Compliant" },
    { value: "CE Certified", label: "CE Certified" },
  ];

  return (
    <div className="container py-4">
      <h4 className="mb-3">Rental Advanced Search</h4>

      <button className="btn btn-sm btn-outline-danger w-100 mb-3 fw-bold" onClick={clearFilters}>
        Clear Filters
      </button>

      {subcategories.length > 0 && (
        <div className="mb-2">
          <Select
            isClearable
            isSearchable
            placeholder="Subcategory..."
            options={subcategoryOptions}
            value={subcategoryOptions.find(o => o.value === filters.subcategoryId) || null}
            onChange={(opt) => handleSelectChange("subcategoryId", opt)}
            styles={customSelectStyles}
          />
        </div>
      )}

      <div className="mb-2">
        <Select
          isClearable
          isSearchable
          placeholder="Year..."
          options={yearOptions}
          value={yearOptions.find(o => o.value === String(filters.year)) || null}
          onChange={(opt) => handleSelectChange("year", opt)}
          styles={customSelectStyles}
        />
      </div>

      <div className="mb-2">
        <Select
          isClearable
          isSearchable
          placeholder="Region..."
          options={regionOptions}
          value={regionOptions.find(o => o.value === filters.regionId) || null}
          onChange={(opt) => handleSelectChange("regionId", opt)}
          styles={customSelectStyles}
        />
      </div>

      <div className="mb-2">
        <Select
          isClearable
          isSearchable
          placeholder="Brand..."
          options={brandOptions}
          value={brandOptions.find(o => o.value === filters.brandId) || null}
          onChange={(opt) => handleSelectChange("brandId", opt)}
          styles={customSelectStyles}
        />
      </div>

      <div className="mb-2">
        <Select
          isClearable
          isSearchable
          placeholder="Model..."
          options={modelOptions}
          value={modelOptions.find(o => o.value === filters.modelId) || null}
          onChange={(opt) => handleSelectChange("modelId", opt)}
          styles={customSelectStyles}
        />
      </div>

      <div className="mb-2">
        <Select
          isClearable
          isSearchable
          placeholder="Condition..."
          options={conditionOptions}
          value={conditionOptions.find(o => o.value === filters.condition) || null}
          onChange={(opt) => handleSelectChange("condition", opt)}
          styles={customSelectStyles}
        />
      </div>

      <div className="mb-2">
        <Select
          isClearable
          isSearchable
          placeholder="Availability..."
          options={availabilityOptions}
          value={availabilityOptions.find(o => o.value === filters.availabilityStatus) || null}
          onChange={(opt) => handleSelectChange("availabilityStatus", opt)}
          styles={customSelectStyles}
        />
      </div>

      <div className="mb-2">
        <Select
          isClearable
          isSearchable
          placeholder="Features..."
          options={featureOptions}
          value={featureOptions.find(o => o.value === filters.features) || null}
          onChange={(opt) => handleSelectChange("features", opt)}
          styles={customSelectStyles}
        />
      </div>

      <div className="mb-2">
        <Select
          isClearable
          isSearchable
          placeholder="Certifications..."
          options={certificationOptions}
          value={certificationOptions.find(o => o.value === filters.certifications) || null}
          onChange={(opt) => handleSelectChange("certifications", opt)}
          styles={customSelectStyles}
        />
      </div>
    </div>
  );
}

export default RentalAdvancedSearch;
